<h2  style="text-align:center;margin-bottom: 0;">{{data.title}}</h2>
<br><br>
<mat-dialog-content style="padding-top: 0;">
    <mat-form-field >
    <mat-select [(value)]="idParamentro" (selectionChange)="changeParametro()">
        <ng-container *ngFor="let parametroo of data.parametroInsert">
            <mat-option [value]="parametroo.id">
                {{parametroo.parametro}}
            </mat-option>
        </ng-container>
  
    </mat-select> 
    </mat-form-field>

    <br><br>
    <div insert-form class="flex flex-column gap-2">
        <form *ngIf="item" [formGroup]="formUpdate"> 
          <div  class="col-12 md:col-12 lg:col-12" *ngIf="item" style="padding:0px;margin-bottom:10px">
            <mat-form-field  *ngIf="item?.tipologia=='chimico_fisico' || item?.tipologia=='antiparassitario'">
              <mat-label>Loq</mat-label>
              <mat-select  formControlName="valoreLoq"  (selectionChange)="toFormGroup(formUpdate)">
                <mat-option value=""></mat-option>
                <mat-option value="<"><</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field  *ngIf="item?.tipologia=='microbiologico'" >
              <mat-label>Lsf</mat-label>
              <mat-select  formControlName="valoreLfs"  (selectionChange)="toFormGroup(formUpdate)">
                <mat-option value=""></mat-option>
                <mat-option value=">">></mat-option>
              </mat-select>
            </mat-form-field>
          </div>
     
          <div  class="col-12 md:col-12 lg:col-12" *ngIf="item" style="padding:0px;margin-bottom:10px">
            <app-input-number name="valoreArrotondato"  *ngIf="item?.tipologia!='qualitativo'"   placeholder="Valore Arrotondato" [form]="formUpdate"></app-input-number>
            <app-input-number name="valoreRapportoProva"  *ngIf="((item?.tipologia=='chimico_fisico' || item?.tipologia=='antiparassitario') && formUpdate.get('valoreLoq')?.value==null) || (item?.tipologia=='microbiologico' && formUpdate.get('valoreLfs')?.value==null)"   placeholder="Valore Rapporto Prova" [form]="formUpdate"></app-input-number>
            <!--nel caso si trattasse di parametri tipo chimico fisico antiparassitario con loq < -->
            <app-input-number 
            name="loq" 
            *ngIf="((item?.tipologia == 'chimico_fisico' && formUpdate.get('valoreLoq')?.value == '<') || 
                    (item?.tipologia == 'antiparassitario' && formUpdate.get('valoreLoq')?.value == '<'))" 
            placeholder="Valore Loq" 
            [form]="formUpdate">
          </app-input-number>
            <!--nel caso si trattasse di parametri tipo microbiologico con lsf > -->
            <app-input-number name="lfs"  *ngIf="(item?.tipologia=='microbiologico' && formUpdate.get('valoreLfs')?.value=='>')"   placeholder="Valore Lfs" [form]="formUpdate"></app-input-number>
            <!--nel caso si trattasse di parametri tipo odore-->
            <mat-form-field  *ngIf="item?.tipologia=='qualitativo'" >
              <mat-label>valore</mat-label>
              <mat-select  formControlName="valoreRapportoProva"  (selectionChange)="toFormGroup(formUpdate)">
                <mat-option [value]="0">NO</mat-option>
                <mat-option [value]="1">SI</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div  class="col-12 md:col-12 lg:col-12" style="padding:0px;margin-bottom:10px" >
            <app-input-text name="incertezza"   placeholder="Incertezza" [form]="formUpdate"></app-input-text>
          </div>
          <div  class="col-12 md:col-12 lg:col-12" style="padding:0px;margin-bottom:10px">
            <app-input-text name="metodo"   placeholder="Metodo" [form]="formUpdate"></app-input-text>
          </div>
        </form>

        </div>
</mat-dialog-content>
<mat-dialog-actions class="my-padding-dialog justify-content-end gap-3">
    <app-button label="Salva" [fullWidth]="false" (click)="saveData()" raised></app-button>
    <app-button label="Chiudi" [fullWidth]="false" (click)="closeModal()" raised></app-button>
</mat-dialog-actions>